import type { ValueOf } from '#layers/base/types/utils';

export const SortDirection = {
	Ascending: 'asc',
	Descending: 'desc',
} as const;

export type SortDirection = ValueOf<typeof SortDirection>;

export const SORT_DIRECTIONS: readonly SortDirection[] = [SortDirection.Ascending, SortDirection.Descending];

const sortDirections = new Set<string>(SORT_DIRECTIONS);

export function isSortDirection(value: string): value is SortDirection {
	return sortDirections.has(value);
}
